"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationPointType = void 0;
var LocationPointType;
(function (LocationPointType) {
    LocationPointType[LocationPointType["Private"] = 0] = "Private";
    LocationPointType[LocationPointType["Shared"] = 1] = "Shared";
})(LocationPointType || (exports.LocationPointType = LocationPointType = {}));
//# sourceMappingURL=LocationPointType.js.map